var _path, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashelio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 200,
    viewBox: "0 0 200 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 10        A18 18 0 1 0 38 38",
    fill: "none",
    stroke: "#0163FF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 24,
    r: 5,
    fill: "#0163FF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 34,
    fontSize: 40,
    fontFamily: "Inter, sans-serif",
    fill: "rgb(47 43 61 / 0.9)",
    fontWeight: 600
  }, "\n    ashelio\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashelio);
export default __webpack_public_path__ + "static/media/cashelio.bb5a28402698bf7d8589a2dd5dafc78c.svg";
export { ForwardRef as ReactComponent };